export default __webpack_public_path__ + "static/img/prom-bp-back.f255d05.jpg";